const messages = {
  bonus: {
    title: "Преглед на бонус кредитите",
    description: "Бонусите в евро се присъждат на участващите компании въз основа на подадените данни за продажбите.",
    lastMonth: "Минал месец",
    currentMonth: "Текущ месец",
    totalCurrentYear: "Общо за текущата година",
    totalLastYear: "Общо за миналата година",
  },
  points: {
    title: "Преглед на точковите кредити",
    period: "Текуща календарна година ({year})",
    totalAwarded: "Общо начислени точки",
    redeemed: "Използвани точки",
    totalBalance: "Общ баланс точки",
    redemptionRate: "Осребрени точки като процент от присъдените точки",
    averageAwarded: "Средно присъдени точки на закупена гума",
    standardAwarded: "Нетни точки от изчислените редове за продажба, включително връщания",
    bsPlusInclBooster: "Точки от редове за продажба с положително количество",
    perTire: "Осребрени точки на закупена гума",
  },
  tires: {
    title: "Преглед на количеството гуми",
    description: "Гуми, закупени от клиентите",
    prevMonth: "Предишен месец",
    totalLastYear: "Общо за миналата година",
    purchaseIndirect: "Покупка чрез търговец на едро (непряко)",
    purchaseDirect: "Покупка чрез търговец на едро (пряко)",
    totalCurrentYear: "Общо за текущата година",
    currentMonth: "Текущ месец",
  },
  participating: {
    title: "Преглед на участващите клиенти",
    description: "Компаниите, които се регистрират в BRIDGESTONE PLUS, могат да бъдат свързани от нас чрез клиентски номер.",
    total: "Общо",
    newThisMonth: "Нови този месец",
    newThisYear: "Нови тази година",
    createdInCurrentMonth: "Създадени през текущия месец (от администратор)",
    loginsCurrentYear: "Влизания през текущата година (след приемане на условията)",
  },
  brand: {
    title: "Марка",
    description: "Вашите покупки в детайли",
    centerTitle: "По\nмарка",
  },
  rim: {
    title: "Джанта",
    centerTitle: "По размер\nна джантата",
  },
  tireGoals: {
    title: "Цели за изпълнение на гуми",
    subtitle: "Печелете точки за вашите покупки на гуми.",
    centerTitle: "По\nразмер гума",
    tiresRemaining: "Оставащи гуми",
    progressionTarget: "Цел за прогрес: ",
    pointsEarnedPurchases: "точки, спечелени\n" + "от вашите\n" + "покупки",
    pointsEarnedBoosters: "точки, спечелени\n" + "от\n" + "boosters",
    purchasesDetail: "Вашите покупки в детайли",
    cta: "Научете повече за вашите точки",
    pointsTitle: "Вашите точки",
    pointsSubtitle: "Точки, спечелени от вашите покупки на Bridgestone",
    achievementsTitle: "Вашите постижения",
    achievementsSubtitle: "Вашият годишен ангажимент:",
    achievementsSubtitle2: "гуми",
  },
  score: {
    title: "Резултат",
    total: "Общо",
    credits: "Кредити в",
    deductions: "Удръжки в",
        unlockedPoints: "Отключени точки",
        pendingPoints: "Очакващи точки",
  },
  score_extended: {
    title1: "Баланс точки",
    title2: "Бонус в евро",
    balance: "Баланс точки",
    bonus_in_euro: "Бонус в евро",
    date: "Дата",
    added_points: "Добавени точки в",
    total_bands: "Общо марки",
    goal: "Цел",
    tyres_previous_year: "Продадени гуми миналата година",
    tyres_current_year: "Продадени гуми тази година",
    target_this_year: "Цел за продажби тази година",
    bonus_this_year: "Спечелен бонус (€)",
    loyal_minimum: "Минимално ниво на лоялност",
    bonus_multiplier: "Коефициент на бонуса",
  },
  lastImport: {
    label: "Последен импорт на данни за продажби:",
    on: "на",
  },
  wholesalerTable: {
    title: "Участващи клиенти в детайли",
    description: "По-долу ще намерите компаниите, които са се регистрирали в BRIDGESTONE PLUS с клиентския номер на вашата компания. Можете да използвате филтрите за различно сортиране или търсачката, за да откриете клиенти.",
    columns: {
      customer_number: "Клиентски №",
      address_company_name: "Компания",
      address_street: "Улица и номер",
      address_postal_code: "Пощенски код",
      address_city: "Град",
      last_registration: "Последна регистрация",
      network: "Мрежа",
      profile_group: "Група",
      tires_amount: "Брой гуми",
      point_balance: "Точков баланс",
      bonus: "Бонус",
      details: "Детайли",
    },
    searchPlaceholder: "Търсене",
  },
  dealerTable: {
    columns: {
      date: "Дата",
      wholesaler_bs_plus: "Търговец BS+",
      customer_number: "Клиентски номер",
      article: "Артикул",
      brand: "Марка",
      product: "Продукт",
      type: "Тип",
      inch: "Инч",
      season: "Сезон",
      amount: "Количество",
      points: "Точки",
      activity: "Активност",
      total_points: "Общо точки",
    },
    title: "Таблица на дилърите",
    description: "Преглед на активността на дилърите",
  },
  business_units: {
    title: "Бизнес единици",
    centerTitle: "По\nединица",
  },
  season: {
    title: "Сезон",
    centerTitle: "По време\nна годината",
  },
};

export default {
  messages,
};
